import { h, Component } from 'preact';
import 'store/bolt/showtimesLoader';
import 'store/bolt/homeEntLoader';
import 'store/bolt/pressKitLoader';

import { joinClasses, accessNested } from 'utils/utils';

import s from 'components/bolt/sidePanelLoader/sidePanelLoader.sss';

export default class SidePanelLoader extends Component {
	constructor(props) {
		super(props);
		if (props.key === 'showtimesLoader') {
			this.compName = 'showtimes';
		} else if (props.key === 'homeEntLoader') {
			this.compName = 'homeEnt';
		} else if (props.key === 'pressKitLoader') {
			this.compName = 'pressKit';
		}
		this.load = this.load.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.store[this.compName]?.show) {
			this.load();
		}
	}

	async load() {
		if (this.loadStarted) {
			return;
		}
		this.loadStarted = true;

		const useShowtimes2 = this.props.store?.appData.options.useShowtimes2;
		const useHomeEnt2 = this.props.store?.appData.options.useHomeEnt2;

		let component;
		if (this.compName === 'showtimes') {
			component = useShowtimes2 ?
				await import(/* webpackChunkName: "showtimes2" */ `components/bolt/showtimes/showtimes2`) :
				await import(/* webpackChunkName: "showtimes" */ `components/bolt/showtimes/showtimes`);
		} else if (this.compName === 'homeEnt') {
			component = useHomeEnt2 ?
				await import(/* webpackChunkName: "homeEnt2" */ `components/bolt/homeEnt/homeEnt2`) :
				await import(/* webpackChunkName: "homeEnt" */ `components/bolt/homeEnt/homeEnt`);
		} else if (this.compName === 'pressKit') {
			component = await import(/* webpackChunkName: "pressKit" */ `components/bolt/pressKit/pressKit`);
		}

		this.setState({ component });
	}


	render(props) {
		let comp = props.store[this.compName];
		let displayed = comp?.show;
		let animate = comp?.animate;
		let { pushDown, height, cookieBannerOpen } = accessNested(props, 'store.cookies') || {};
		const externalBannerOpen = accessNested(props, 'store.externalCookieBanner.bannerOpen');
		const cookieMode = externalBannerOpen || (pushDown && cookieBannerOpen);

		if (externalBannerOpen) {
			height = accessNested(props, 'store.externalCookieBanner.height');
		}

		const cookieHeaderPushDown = {
			top: `${height}px`,
			height: `calc(var(--windowHeight) - ${height}px)`
		};

		let content = <div class={s.placeholder} key="placeholder" />;
		if (this.state.component) {
			const Comp = this.state.component.default;
			content = <Comp {...props} key={this.compName} />;
		}

		return (
			<div class={joinClasses({ s, bugFix: true, container: true, displayed, animate })} style={cookieMode && cookieHeaderPushDown}>
				{content}
			</div>
		);
	}
}
